// extracted by mini-css-extract-plugin
export default {"tag":"tag-module--tag--uI5Lf"};